import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from '../../../environments/environment'
import { JSONRpcResponse } from '../../Interfaces/JSONRpcResponse'
import { JSONRpc } from '../service-jsonrpc'

@Injectable({
	providedIn: 'root',
})
export class WorkflowService {
	constructor(private http: HttpClient) { }

	can(id: any, transition: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.workflow:can',
			params: {
				id: id,
				transition: transition,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	transitions(id: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.workflow:transitions',
			params: {
				id: id,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	set(id: any, transition: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.workflow:set',
			params: {
				id: id,
				transition: transition,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
	get(id: any, transition: any): Observable<JSONRpcResponse> {
		let rpcMethod = new JSONRpc({
			jsonrpc: '2.0',
			method: 'webservice.workflow:get',
			params: {
				id: id,
				transition: transition,
			},
		})
		return this.http.post<JSONRpc>(environment.webservice, rpcMethod)
	}
}
